module.exports = __webpack_public_path__ + "static/media/Steering_Black.ac77d85c.webp";